import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import BasicDropdownToggle, { BasicDropdownToggleProps as Props } from '../BasicDropdownToggle';
import { PopperDropdownContext } from './PopperDropdownContext';
const PopperDropdownToggle = (_param)=>{
    var { children  } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    const { setToggleRef  } = useContext(PopperDropdownContext);
    return /*#__PURE__*/ React.createElement(BasicDropdownToggle, _extends({}, props, {
        innerRef: setToggleRef
    }), children);
};
PopperDropdownToggle.displayName = 'PopperDropdownToggle';
export default PopperDropdownToggle;
